import '../../assets/base.css';
import '../Lk/Index.css';
import { Outlet } from 'react-router';
import { Fragment } from 'react';
import ResizeDetector from 'react-resize-detector';
import AppHeader from '../../Layout/AppHeader';
import AppSidebar from '../../Layout/AppSidebar';
import LoadFirstData from '../../util/LoadFirstData';
import { useSelector } from 'react-redux';
import ChangedModal from './Company/ChangedModal';
//import axios from 'axios';

function Index() {
  const stateMenu = useSelector((state) => state.menuData);//Настройки приложения
  const stateSize = useSelector((state) => state.size);//Настройки приложения

  /*axios.interceptors.response.use(response => response, error => {

    console.log('ПЕРЕХВАТ!!!')
    if (!error.response) {
      console.error('Сервер не отвечает', error.request); // Нет ответа от сервера
    } else if (!error.response.data) {
      console.error('Нет данных в ответе', error.response); // Ответ не содержит данных
    } else {
      console.error('Сервер вернул ошибку:', error.response); // Ошибка пришла от сервера
    }
    return Promise.reject(error); // Передаем ошибку обратно
  });
*/

  return (
    <div>
      <Fragment>
        <div className={stateSize.desktop === true ?
          'app-container app-theme-white fixed-header fixed-sidebar fixed-footer' + (stateMenu.menuMainShow === false ? ' closed-sidebar' : +'')
          :
          'app-container app-theme-white fixed-header fixed-sidebar fixed-footer closed-sidebar closed-sidebar-mobile' + (stateMenu.menuMainMobileShow === true ? ' sidebar-mobile-open' : +'')
        }>
          <Fragment>
            <AppHeader />
            <div className="app-main">
              <AppSidebar />
              <div className="app-main__outer">
                <div className="app-main__inner">
                  <div>
                    <LoadFirstData />
                    <ChangedModal />

                    <Outlet>

                    </Outlet>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
          <ResizeDetector handleWidth /*onResize={this.onResize}*/ />
        </div>
      </Fragment>
    </div>
  );
}

export default Index;
